<template>
  <span v-if="!input" class="pb-stars star-display" role="img" :aria-label="'Rated ' + value + ' out of 5'">
    <i v-for="n in 5" :key="n" :class="['mdi', n <= value ? 'mdi-star' : 'mdi-star-outline', { off: n > value }]" aria-hidden="true"></i>
  </span>
  <fieldset v-else :class="['star-input', { small }]" :disabled="disabled">
    <legend class="star-legend">{{ legend }}<span v-if="!required" class="star-optional"> (optional)</span></legend>
    <div class="star-row" @mouseleave="hover = 0">
      <label v-for="n in 5" :key="n" :class="['star', { on: n <= shown }]" @mouseenter="hover = n">
        <input class="pb-sr-only" type="radio" :name="name" :value="n" :checked="value === n" :required="required && n === 1"
               :tabindex="tabIndex(n)" @change="$emit('input', n)">
        <i class="mdi mdi-star" aria-hidden="true"></i>
        <span class="pb-sr-only">{{ n }} out of 5</span>
      </label>
      <span class="star-word" aria-hidden="true">{{ word }}</span>
      <button v-if="value && !required && !disabled" type="button" class="star-clear" @click="$emit('input', null)">Clear</button>
    </div>
  </fieldset>
</template>

<script>
const WORDS = ['', 'Poor', 'Fair', 'Good', 'Very good', 'Excellent'];
export default {
  name: 'StarRating',
  props: {
    value: { type: Number, default: null },
    input: { type: Boolean, default: false },
    name: { type: String, default: 'rating' },
    legend: { type: String, default: 'How would you rate your experience?' },
    required: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    small: { type: Boolean, default: false }
  },
  data: () => ({ hover: 0 }),
  computed: {
    shown() { return this.hover || this.value || 0; },
    word() { return WORDS[this.shown] || ''; }
  },
  methods: {
    // A radio group is one tab stop; arrow keys move between the stars.
    tabIndex(n) { return (this.value ? this.value === n : n === 1) ? 0 : -1; }
  }
};
</script>

<style scoped>
.star-display i{font-size:inherit}
.star-input{border:0;margin:0;padding:0;min-width:0}
.star-legend{padding:0;margin-bottom:8px;font-weight:600;font-size:inherit;color:inherit}
.star-optional{font-weight:500;color:#6B635B}
.star-row{display:flex;align-items:center;gap:2px;flex-wrap:wrap}
/* The shell styles every <label> with !important (AppShell.vue); each star is a label for its radio. */
.star{position:relative;display:inline-grid;place-items:center;width:44px;height:44px;border-radius:10px;cursor:pointer;color:#D4C9B8!important;
  font-size:30px!important;margin:0!important;transition:color .12s ease,transform .12s ease}
.star.on{color:#B7791F!important}
.small .star{width:32px;height:32px;font-size:22px!important}
.small .star-legend{margin-bottom:4px}
.small .star-word{font-size:12px;margin-left:6px}
.star:hover{transform:scale(1.06)}
.star:focus-within{outline:2px solid var(--brand,#B4472B);outline-offset:1px}
.star-input[disabled] .star{cursor:default}
.star-input[disabled] .star:hover{transform:none}
.star-word{margin-left:10px;font-size:14px;color:#4F4A45;min-width:72px}
.star-clear{margin-left:4px;border:0;background:none;color:#6B635B;font:600 13px var(--font-body);text-decoration:underline;cursor:pointer;min-height:32px}
@media(prefers-reduced-motion:reduce){.star{transition:none}.star:hover{transform:none}}
</style>
